import { all } from "redux-saga/effects";
import { saleSetSaga } from "./saleSetSaga";

export default function* saleSetSagaWrapper() {
    yield all([
        saleSetSaga()
    ]);
}
